/* @generated from adl module SyntaxHighlighting */

import * as ADL from './runtime/adl';
import * as SrcLoc from './SrcLoc';

export enum SyntaxHighlightingColor {
  binding,
  comment,
  import_,
  keyword,
  lambda,
  list,
  module_,
  numericLiteral,
  operator,
  patVar,
  stringLiteral,
  tuple,
  typeClass,
  typeCon,
  typeVar,
  variable,
}

const SyntaxHighlightingColor_AST : ADL.ScopedDecl =
  {"moduleName":"SyntaxHighlighting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"binding","default":{"kind":"nothing"},"name":"binding","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"comment","default":{"kind":"nothing"},"name":"comment","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"import_","default":{"kind":"nothing"},"name":"import_","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"keyword","default":{"kind":"nothing"},"name":"keyword","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"lambda","default":{"kind":"nothing"},"name":"lambda","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"list","default":{"kind":"nothing"},"name":"list","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"module_","default":{"kind":"nothing"},"name":"module_","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"numericLiteral","default":{"kind":"nothing"},"name":"numericLiteral","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"operator","default":{"kind":"nothing"},"name":"operator","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"patVar","default":{"kind":"nothing"},"name":"patVar","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"stringLiteral","default":{"kind":"nothing"},"name":"stringLiteral","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"tuple","default":{"kind":"nothing"},"name":"tuple","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"typeClass","default":{"kind":"nothing"},"name":"typeClass","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"typeCon","default":{"kind":"nothing"},"name":"typeCon","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"typeVar","default":{"kind":"nothing"},"name":"typeVar","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"variable","default":{"kind":"nothing"},"name":"variable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SyntaxHighlightingColor","version":{"kind":"nothing"}}};

export const snSyntaxHighlightingColor: ADL.ScopedName = {moduleName:"SyntaxHighlighting", name:"SyntaxHighlightingColor"};

export function texprSyntaxHighlightingColor(): ADL.ATypeExpr<SyntaxHighlightingColor> {
  return {value : {typeRef : {kind: "reference", value : snSyntaxHighlightingColor}, parameters : []}};
}

export interface SyntaxHighlightingSpan {
  range: SrcLoc.LineColRange;
  color: SyntaxHighlightingColor;
}

export function makeSyntaxHighlightingSpan(
  input: {
    range: SrcLoc.LineColRange,
    color: SyntaxHighlightingColor,
  }
): SyntaxHighlightingSpan {
  return {
    range: input.range,
    color: input.color,
  };
}

const SyntaxHighlightingSpan_AST : ADL.ScopedDecl =
  {"moduleName":"SyntaxHighlighting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"range","default":{"kind":"nothing"},"name":"range","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineColRange"}},"parameters":[]}},{"annotations":[],"serializedName":"color","default":{"kind":"nothing"},"name":"color","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SyntaxHighlighting","name":"SyntaxHighlightingColor"}},"parameters":[]}}]}},"name":"SyntaxHighlightingSpan","version":{"kind":"nothing"}}};

export const snSyntaxHighlightingSpan: ADL.ScopedName = {moduleName:"SyntaxHighlighting", name:"SyntaxHighlightingSpan"};

export function texprSyntaxHighlightingSpan(): ADL.ATypeExpr<SyntaxHighlightingSpan> {
  return {value : {typeRef : {kind: "reference", value : snSyntaxHighlightingSpan}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "SyntaxHighlighting.SyntaxHighlightingColor" : SyntaxHighlightingColor_AST,
  "SyntaxHighlighting.SyntaxHighlightingSpan" : SyntaxHighlightingSpan_AST
};
